module.exports = __webpack_public_path__ + "images/icons_v2/check-38ee90a8.svg";